import styled, { css } from 'styled-components'
import tw from 'twin.macro'

export const FormWrapper = styled.div<{
  backgroundColor?: 'orange' | 'blue' | 'black-deep'
}>`
  ${tw`relative mx-auto flex flex-col w-full font-display`}
  max-width: 1024px;

  ${({ backgroundColor }) => {
    switch (backgroundColor) {
      case 'orange':
        return tw`bg-orange`
      case 'blue':
        return tw`bg-blue`
      case 'black-deep':
        return tw`bg-black__deep`
      default:
        return tw`bg-grey__light`
    }
  }}

  // You Fitness template
  ${({ backgroundColor }) =>
    backgroundColor === 'black-deep' &&
    css`
      ${FormLabel},
      h2 {
        ${tw`text-white`}
      }
    `}
`

export const Form = styled.form<{ layout?: string }>`
  ${tw`mt-4`}
  z-index: 1;

  .you-fitness__control {
    min-height: 48px;
  }

  .you-fitness__single-value {
    ${tw`text-sm`}
  }

  ${props =>
    props.layout === 'TwoColumn' &&
    css`
      ${FormFields} {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        > div {
          flex: 1 1 calc(50% - 16px);
          text-align: left;

          label {
            font-size: 16px;
          }

          &:nth-child(5):last-child,
          &:nth-child(3):last-child,
          &:nth-child(1):last-child {
            flex: 1 1 100%;
          }
        }
      }
    `}
`

export const MemberEnquiryForm = styled(Form)`
  ${tw`flex flex-wrap -mx-2 justify-center`}
`

export const PreFormText = styled.p`
  ${tw`px-4 mb-0 text-white text-center uppercase text-sm`}
`

export const FormTitle = styled.h1`
  ${tw`px-4 pt-8 mb-0 font-body`}
`

export const FormGroup = styled.div<{ col?: number; paddingX?: number }>`
  ${tw`flex flex-col mb-7 relative w-full`}

  ${({ col }) => {
    if (col === 1) return tw`w-full`
    else if (col === 2) return tw`lg:w-2/5`
    else if (col === 3) return tw`lg:w-1/3`
    else return ''
  }}

  ${({ paddingX }) => {
    if (paddingX === 1) return tw`lg:px-1`
    else if (paddingX === 2) return tw`lg:px-2`
    else if (paddingX === 3) return tw`lg:px-3`
    else if (paddingX === 4) return tw`lg:px-4`
    else if (paddingX === 5) return tw`lg:px-5`
    else if (paddingX === 6) return tw`lg:px-6`
    else return ''
  }}

  > input,
  .react-datepicker__input-container input,
  .you-fitness-fileinput {
    ${tw`text-sm`}
    height: 48px;
  }

  .you-fitness-error,
  .error.you-fitness__control {
    ${tw`border-2 border-red`}
  }

  label span {
    ${tw`text-white text-sm`}
  }
`

export const FormLabel = styled.label<{ error?: boolean }>`
  ${tw`text-white font-medium text-sm mb-1`}

  ${props =>
    props.error &&
    css`
      ${tw`text-red`}
    `}
`

export const ErrorMessage = styled.span`
  ${tw`text-red italic`}
  font-size: 13px;
  top: 100%;
`

export const CloseWrapper = styled.span`
  ${tw`absolute top-0 right-0 p-4 cursor-pointer`}
`

export const ButtonWrap = styled.div`
  ${tw`justify-center flex w-full`}
`

export const FormFields = styled.div``
